<template>
  <ms-container-wrap>
    <template v-slot:mstemplate>
      <div class="d-flex align-center mb-4">
        <h4 class="title">Your Timeline</h4>
        <v-btn class="mx-1" text small icon color="accent" @click="init">
          <v-icon dark>mdi-refresh</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="accent" dark class="mr-1" depressed small
          :disabled="updatingChanges"
          @click="onEdit()">
          <v-icon left>mdi-plus</v-icon> Add Task
        </v-btn>
      </div>
      <div v-if="loading">
        <v-progress-circular indeterminate size="12" width="1" class="mr-1"></v-progress-circular>
        <span class="caption">Loading timeline... Please wait</span>
      </div>
      <div v-if="!loading">
        <v-timeline dense v-if="results.length !== 0">
          <v-timeline-item
            v-for="(item, index) in results"
            :key="index"
            color="accent"
            fill-dot
            small
          >
            <span slot="opposite">Tus eu perfecto</span>
            <v-card elevation="1">
              <v-card-title class="subtitle-1 d-flex justify-space-between">
                {{ item.msg }}
                <v-btn v-if="item.status !== statuses.FINISHED"
                  color="success" outlined
                  depressed small
                  @click.prevent="onStatusChange(item, statuses.FINISHED, index)"
                >Finish Task</v-btn>
                <v-btn v-if="item.status === statuses.FINISHED"
                  color="secondary" outlined
                  depressed small
                  @click.prevent="onStatusChange(item, statuses.ONGOING, index)"
                >Restart</v-btn>
              </v-card-title>
              <v-card-text class="d-flex justify-space-between">
                <span>Started: <strong>{{ item.date | moment('from') }}</strong></span>
                <span v-if="item.status === statuses.FINISHED">
                  Completed: <strong>{{ item.modifiedAt | moment('from') }}</strong>
                </span>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
        <v-alert
          dense
          prominent
          color="secondary"
          dark
          v-if="results.length === 0"
        >
          You're just 1 step away from recording milestone.
          <a href="javascript:void(0)">Click here</a> to record new milestone.
        </v-alert>
      </div>
      <v-dialog v-model="dialog" persistent max-width="480px">
        <v-card>
          <v-card-title>
            <h4 class="title">{{ formHeading }}</h4>
          </v-card-title>
          <v-card-text>
            <milestone-form v-if="dialog"
              @close="onClose"
              @save="onSave"
              :form-data="chosenItem">
            </milestone-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </ms-container-wrap>
</template>

<style scoped>
a {
  color: inherit;
}
</style>

<script>
import { mapState, mapActions } from 'vuex';
import types from '@/store/types';
import ContainerWrap from '@/components/ContainerWrap.vue';
import MilestoneForm from '@/components/MilestoneForm.vue';

export default {
  name: 'milestones-page',
  components: {
    'ms-container-wrap': ContainerWrap,
    MilestoneForm,
  },
  data: () => ({
    dialog: false,
    chosenItem: undefined,
    loading: false,
    search: '',
    results: [],
    updatingChanges: false,
    statuses: {
      FINISHED: 'finished',
      ONGOING: 'ongoing',
      CLOSED: 'closed',
    },
  }),
  computed: {
    ...mapState([
      'user',
    ]),
    formHeading() {
      return `${this.chosenItem && this.chosenItem.id ? 'Update' : 'New'} Issue`;
    },
  },
  methods: {
    ...mapActions('db', {
      fetchResults: types.GET_ISSUES,
      deleteItem: types.DELETE_ISSUE,
      deleteSelected: types.DELETE_ALL_ISSUES,
      updateMileStone: types.UPDATE_ISSUE,
    }),
    noop() {},
    onClose() {
      this.dialog = false;
    },
    onStatusChange(item, status, index) {
      const payload = {
        id: item.id,
        status,
      };
      this.updateMileStone(payload)
        .then(() => {
          this.results[index].status = status;
          this.results[index].modifiedAt = Date.now();
        });
    },
    onSave() {
      this.dialog = false;
      this.loadResults();
    },
    onEdit(item) {
      this.chosenItem = item ? {
        ...item,
      } : undefined;
      this.dialog = true;
    },
    onDelete(item) {
      if (!item || !item.id) {
        return;
      }
      this.updatingChanges = true;
      this.deleteItem(item.id)
        .then(() => {
          const index = this.results.indexOf(item);
          this.results.splice(index, 1);
        }).catch(() => {})
        .finally(() => {
          this.updatingChanges = false;
        });
    },
    onMulitpleDelete() {
      if (!this.selected.length) {
        return;
      }
      this.updatingChanges = true;
      this.deleteSelected(this.selected).then(() => {
        this.loadResults();
      }).catch(() => {})
        .finally(() => {
          this.updatingChanges = false;
        });
    },
    loadResults() {
      // this.loading = true;
      // this.fetchResults()
      //   .then((results) => {
      //     this.results = Array.isArray(results) ? results : [];
      //   }).catch(() => {})
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
    handleDropdown(item) {
      this[item.action]();
    },
    init() {
      this.loadResults();
    },
  },

  created() {
    this.init();
  },
};
</script>
